import { render, staticRenderFns } from "./pdfSignBridge.vue?vue&type=template&id=8522bf86&scoped=true"
import script from "./pdfSignBridge.vue?vue&type=script&lang=js"
export * from "./pdfSignBridge.vue?vue&type=script&lang=js"
import style0 from "./pdfSignBridge.vue?vue&type=style&index=0&id=8522bf86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8522bf86",
  null
  
)

export default component.exports